import { useCallback } from 'react'
import showsApi from '../client/shows-api'
import { ShowDetailDTO } from '../types/Show'
import { useApiData } from './useApiData'

export function useShowDetails(showId?: string) {
  const parsedShowId = showId ? parseInt(showId, 10) : undefined
  const isValidShowId = parsedShowId !== undefined && !isNaN(parsedShowId)

  const fetchShowDetails = useCallback(
    () => showsApi.getById(parsedShowId!),
    [parsedShowId]
  )

  const { data, isLoading, error, status, refetch } = useApiData<ShowDetailDTO>(
    fetchShowDetails,
    [parsedShowId],
    {
      errorMessage: 'Failed to load tv show details',
      enabled: isValidShowId,
    }
  )

  return {
    data,
    loading: isLoading,
    error,
    status,
    refetch,
  }
}
